import styled from "styled-components";
import { ScrollBar } from "../../Theme/Hyper";
import { useContext, useState, useEffect } from "react";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { ControlContext } from "../../contexts/ControlContext";
import Select from "react-select";
import { DataContext } from "../../contexts/DataContext";
import { APIContext } from "../../contexts/APIContext";
import { IoMdReorder } from "react-icons/io";
import "../UI/Styles/Checkbox.css";

const indicatorOptions = [
  { value: "same", label: "Same" },
  { value: "up", label: "Up" },
  { value: "down", label: "Down" },
  { value: "hide", label: "Hide" },
];

const HighlightOptions = [
  { value: "off", label: "Highlight Off" },
  { value: "white", label: "White Highlight" },
  { value: "gold", label: "Gold Highlight" },
  { value: "red", label: "Red Highlight" },
];

const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 10%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 120px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const Input = styled.input`
  background-color: rgb(34, 36, 43);
  border-radius: 4px;
  border: none;
  padding: 0 1em;
  outline: none;
  color: #fff;
  width: 160px;
  height: 40px;
`;

const HeaderInput = styled(Input)`
  font-weight: 600;
  color: #fff;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
    font-weight: 600;
  }
`;

const ActionPanel = styled(ScrollBar)`
  display: flex;
  margin-bottom: 1em;
  margin-right: 1em;
  box-sizing: border-box;
  min-height: 80vh;
  max-height: 90vh;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  width: 100%;
  overflow-y: auto;
  flex-direction: column;
`;
const SelectContainer = styled(Select)`
  min-width: 160px;
  margin-bottom: 0.5em;
  width: 100%;
`;
const Title = styled.div`
  display: flex;
  margin: 1em;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 1.5rem;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;

  .title-group {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .label {
    display: flex;
    align-items: center;
    height: 40px;
  }

  input {
    height: 40px;
  }
`;

const TableHTML = styled.table`
  width: 100%;
  border-collapse: collapse;

  th {
    font-weight: bold;
  }

  th,
  td {
    text-align: left;
    vertical-align: middle;
    padding: 0.5rem 0.5rem;
  }

  th input,
  td input {
    width: 90%;
  }
`;

const DropdownStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "rgb(34, 36, 43)",
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: "rgb(34, 36, 43)",
      "&:hover": {
        color: "#db0a41",
      },
    };
  },
  control: (provided) => ({
    ...provided,
    backgroundColor: "rgb(34, 36, 43)",
    borderColor: "#384454",
  }),
  valueContainer: (provided) => ({
    ...provided,
    backgroundColor: "rgb(34, 36, 43)",
    borderColor: "#384454",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition, color: "#fff" };
  },
};

function ColumnToggle({ value, onChange }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        background: "rgb(34, 36, 43)",
        color: "#fff",
        border: "none",
        borderRadius: 4,
        padding: "0.5em",
        width: "100%",
      }}
    >
      <option value="reg">Column Highlight Off</option>
      <option value="bold">Column Highlight On</option>
    </select>
  );
}

export default function CustomTable({ game }) {
  const {
    previewGraphic,
    animateGraphic,
    graphicInPreview,
    animateOffGraphic,
    updateGraphic,
    clearPVW,
  } = useContext(GraphicsContext);

  const [table, setTable] = useLocalStorage("hyper-netball-custom-standings", [
    {
      team: "Manchester Thunder",
      badge: "Netball_Badges_100x100/THUNDER.png",
      position: 1,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "Loughborough Lightning",
      badge: "Netball_Badges_100x100/LIGHTNING.png",
      position: 2,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "London Pulse",
      badge: "Netball_Badges_100x100/PULSE.png",
      position: 3,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "Nottingham Forest Netball",
      badge: "Netball_Badges_100x100/FOREST[1].png",
      position: 4,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "London Mavericks",
      badge: "Netball_Badges_100x100/MAVERICKS.png",
      position: 5,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "Leeds Rhinos",
      badge: "Netball_Badges_100x100/RHINOS.png",
      position: 6,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "Dragons",
      badge: "Netball_Badges_100x100/DRAGONS.png",
      position: 7,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "Birmingham Panthers",
      badge: "Netball_Badges_100x100/PANTHERS_2.png",
      position: 8,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
  ]);
  const [headers, setheaders] = useState({
    position: "",
    indicator: "",
    badge: "",
    team: "",
    Column1: "",
    Column2: "",
    Column3: "",
    Column4: "",
  });
  const [titles, settitles] = useState({
    Titletext: "Super League",
    Subtitletext: "",
  });
  const [columnStyles, setColumnStyles] = useState({
    position: "reg",
    indicator: "reg",
    team: "reg",
    Column1: "reg",
    Column2: "reg",
    Column3: "reg",
    Column4: "reg",
  });
  const [activeColumns, setActiveColumns] = useState({
    position: true,
    indicator: true,
    badge: true,
    team: true,
    Column1: true,
    Column2: true,
    Column3: true,
    Column4: true,
  });
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  return (
    <ActionPanel>
      <Title>
        <div className="title-group">
          <span className="label">Title</span>
          <Input
            value={titles.Titletext}
            onChange={(e) =>
              settitles({ ...titles, Titletext: e.currentTarget.value })
            }
          />
        </div>
        <div className="title-group">
          <span className="label">Subtitle</span>
          <Input
            value={titles.Subtitletext}
            onChange={(e) =>
              settitles({ ...titles, Subtitletext: e.currentTarget.value })
            }
          />
        </div>
      </Title>
      <TableHTML>
        <thead>
          <tr>
            <th>
            </th>
            <th>
              <Input
                value={headers.position}
                placeholder="Pos"
                onChange={(e) =>
                  setheaders({ ...headers, position: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.indicator}
                placeholder="Indicator"
                onChange={(e) =>
                  setheaders({ ...headers, indicator: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.badge}
                placeholder="Badge"
                onChange={(e) =>
                  setheaders({ ...headers, badge: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.team}
                placeholder="Name"
                onChange={(e) =>
                  setheaders({ ...headers, team: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.Column1}
                placeholder="Column 1 Header"
                onChange={(e) =>
                  setheaders({ ...headers, Column1: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.Column2}
                placeholder="Column 2 Header"
                onChange={(e) =>
                  setheaders({ ...headers, Column2: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.Column3}
                placeholder="Column 3 Header"
                onChange={(e) =>
                  setheaders({ ...headers, Column3: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.Column4}
                placeholder="Column 4 Header"
                onChange={(e) =>
                  setheaders({ ...headers, Column4: e.currentTarget.value })
                }
              />
            </th>
            <th>
              Row Highlight
            </th>
          </tr>
        </thead>
        <tbody>
          {table?.map((item, index) => {
            return (
              <Row
                key={item.team}
                item={item}
                index={index}
                onChange={(new_item) => {
                  let new_table = [...table];
                  let i = new_table.findIndex((t) => t.team === new_item.team);

                  new_table[i] = new_item;
                  setTable(new_table);
                }}
                onDragStart={(i) => setDraggedIndex(i)}
                draggedIndex={draggedIndex}
                dragOverIndex={dragOverIndex}
                onDragOver={(e) => {
                  e.preventDefault();
                  if (dragOverIndex !== index) {
                    setDragOverIndex(index);
                  }
                }}
                onDragLeave={() => { setDragOverIndex(null); }}
                onDrop={(i) => {
                  setDragOverIndex(null);
                  if (draggedIndex === null || draggedIndex === i) return;
                  setTable((prev) => {
                    const updated = [...prev];
                    const [moved] = updated.splice(draggedIndex, 1);
                    updated.splice(i, 0, moved);
                    return updated.map((row, idx) => ({
                      ...row,
                      position: idx + 1,
                    }));
                  });

                  setDraggedIndex(null);
                }}
              />
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td>
              <ColumnToggle
                value={columnStyles.position}
                onChange={(v) =>
                  setColumnStyles({ ...columnStyles, position: v })
                }
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.indicator}
                onChange={(v) =>
                  setColumnStyles({ ...columnStyles, indicator: v })
                }
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.team}
                onChange={(v) => setColumnStyles({ ...columnStyles, team: v })}
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.Column1}
                onChange={(v) =>
                  setColumnStyles({ ...columnStyles, Column1: v })
                }
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.Column2}
                onChange={(v) =>
                  setColumnStyles({ ...columnStyles, Column2: v })
                }
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.Column3}
                onChange={(v) => setColumnStyles({ ...columnStyles, Column3: v })}
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.Column4}
                onChange={(v) => setColumnStyles({ ...columnStyles, Column4: v })}
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <div className="Property">
              <label className="CheckboxContainer">
                Column Shown
                <input
                  type="checkbox"
                  checked={
                    activeColumns.position ? true : false
                  }
                  onChange={(e) => {
                    setActiveColumns({ ...activeColumns, position: e.currentTarget.checked });
                  }}
                />
                <span className="Checkmark" />
              </label>
            </div>
            </td>
            <td>
              <div className="Property">
              <label className="CheckboxContainer">
                Column Shown
                <input
                  type="checkbox"
                  checked={
                    activeColumns.indicator ? true : false
                  }
                  onChange={(e) => {
                    setActiveColumns({ ...activeColumns, indicator: e.currentTarget.checked });
                  }}
                />
                <span className="Checkmark" />
              </label>
            </div>
            </td>
            <td>
              <div className="Property">
              <label className="CheckboxContainer">
                Column Shown
                <input
                  type="checkbox"
                  checked={
                    activeColumns.badge ? true : false
                  }
                  onChange={(e) => {
                    setActiveColumns({ ...activeColumns, badge: e.currentTarget.checked });
                  }}
                />
                <span className="Checkmark" />
              </label>
            </div>
            </td>
            <td>
              <div className="Property">
              <label className="CheckboxContainer">
                Column Shown
                <input
                  type="checkbox"
                  checked={
                    activeColumns.team ? true : false
                  }
                  onChange={(e) => {
                    setActiveColumns({ ...activeColumns, team: e.currentTarget.checked });
                  }}
                />
                <span className="Checkmark" />
              </label>
            </div>
            </td>
            <td>
              <div className="Property">
              <label className="CheckboxContainer">
                Column Shown
                <input
                  type="checkbox"
                  checked={
                    activeColumns.Column1 ? true : false
                  }
                  onChange={(e) => {
                    setActiveColumns({ ...activeColumns, Column1: e.currentTarget.checked });
                  }}
                />
                <span className="Checkmark" />
              </label>
            </div>
            </td>
            <td>
              <div className="Property">
              <label className="CheckboxContainer">
                Column Shown
                <input
                  type="checkbox"
                  checked={
                    activeColumns.Column2 ? true : false
                  }
                  onChange={(e) => {
                    setActiveColumns({ ...activeColumns, Column2: e.currentTarget.checked });
                  }}
                />
                <span className="Checkmark" />
              </label>
            </div>
            </td>
            <td>
              <div className="Property">
              <label className="CheckboxContainer">
                Column Shown
                <input
                  type="checkbox"
                  checked={
                    activeColumns.Column3 ? true : false
                  }
                  onChange={(e) => {
                    setActiveColumns({ ...activeColumns, Column3: e.currentTarget.checked });
                  }}
                />
                <span className="Checkmark" />
              </label>
            </div>
            </td>
            <td>
              <div className="Property">
              <label className="CheckboxContainer">
                Column Shown
                <input
                  type="checkbox"
                  checked={
                    activeColumns.Column4 ? true : false
                  }
                  onChange={(e) => {
                    setActiveColumns({ ...activeColumns, Column4: e.currentTarget.checked });
                  }}
                />
                <span className="Checkmark" />
              </label>
            </div>
            </td>
          </tr>
        </tfoot>
      </TableHTML>
      <Title>
        <GraphicButton
          onClick={() => {
            let new_table = JSON.parse(JSON.stringify(table)).sort((a, b) => {
              return parseInt(a?.position) - parseInt(b?.position);
            });
            setTable(new_table);
            previewGraphic("Custom Table", {
              table: new_table,
              headers: headers,
              titles: titles,
              columnStyles: columnStyles,
              activeColumns: activeColumns,
              game,
            });
          }}
        >
          Preview
        </GraphicButton>
        <GraphicButton
          green
          onClick={() => {
            animateGraphic("Custom Table", {});
          }}
        >
          IN
        </GraphicButton>
        <GraphicButton
          red
          onClick={() => {
            animateOffGraphic("Custom Table");
          }}
        >
          OUT
        </GraphicButton>
      </Title>
    </ActionPanel>
  );
}

function Row({
  item,
  index,
  onChange,
  onDragStart,
  onDragOver,
  onDrop,
  draggedIndex,
  dragOverIndex,
}) {
  const [isFocused, setIsFocused] = useState(false);

  let translateY = 0;
  if (draggedIndex !== null && dragOverIndex !== null) {
    if (index === dragOverIndex && draggedIndex < index) {
      translateY = 10;
    } else if (index === dragOverIndex && draggedIndex > index) {
      translateY = -10;
    }
  }

  return (
    <tr
      draggable
      onDragStart={(e) => {
        if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT") {
          e.preventDefault();
          return;
        }
        onDragStart(index);
      }}
      onDragOver={onDragOver}
      onDrop={() => onDrop(index)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      style={{
        position: "relative",
        zIndex: isFocused ? 1000 : (dragOverIndex === index ? 100 : 1),
        cursor: "grab",
        transform: `translateY(${translateY}px)`,
        transition: "transform 150ms ease, border 150ms ease",
        borderBottom: (index === dragOverIndex && draggedIndex < index) ? 
        "2px solid #db0a41" 
        : "none",
        borderTop: (index === dragOverIndex && draggedIndex > index) ? 
        "2px solid #0adb93" 
        : "none",
        backgroundColor: (dragOverIndex === index && draggedIndex !== null) ? "rgba(63, 6, 21, 0.07)" : "transparent",
      }}
    >
      <td
      style={{
        textAlign: "center",
        width: "40px",
      }}>
        <IoMdReorder />
      </td>
      <td>
        <Input
          value={item?.position}
          onChange={(e) => {
            onChange({ ...item, position: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <SelectContainer
          styles={DropdownStyles}
          setSize={true}
          value={indicatorOptions.find(
            (option) => option.value === (item?.indicator || "same"),
          )}
          options={indicatorOptions}
          onChange={(e) => {
            onChange({ ...item, indicator: e.value });
          }}
          placeholder="Same"
        />
      </td>
      <td>
        <Input
          value={item?.badge}
          onChange={(e) => {
            onChange({ ...item, badge: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <Input
          value={item?.team}
          onChange={(e) => {
            onChange({ ...item, team: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <Input
          value={item?.Column1}
          onChange={(e) => {
            onChange({ ...item, Column1: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <Input
          value={item?.Column2}
          onChange={(e) => {
            onChange({ ...item, Column2: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <Input
          value={item?.Column3}
          onChange={(e) => {
            onChange({ ...item, Column3: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <Input
          value={item?.Column4}
          onChange={(e) => {
            onChange({ ...item, Column4: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <SelectContainer
          styles={DropdownStyles}
          setSize={true}
          value={HighlightOptions.find(
            (option) => option.value === (item?.highlight || "Highlight off"),
          )}
          options={HighlightOptions}
          onChange={(e) => {
            onChange({ ...item, highlight: e.value });
          }}
          placeholder="Highlight off"
        />
      </td>
    </tr>
  );
}
